<template>
  <div class="company-user-item-info-bd">
    <div class="user-info">
      <el-form label-position="top" :model="form" ref="form" :rules="rules" :validate-on-rule-change="false">
        <el-form-item key="userCode" :label="$t('cui_info_yong_hu_bian_ma')" prop="userCode">
          <el-input v-model="form.userCode" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item key="realName" :label="$t('cui_info_ygxm')" prop="realName">
          <el-input v-model="form.realName" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item key="loginPwd" v-if="type == 'add'" :label="$t('cui_info_deng_lu_mi_ma')" prop="loginPwd">
          <el-input
            autocomplete="off"
            :type="inputType"
            :readonly="inputReadonly"
            v-model="form.loginPwd"
            :placeholder="$t('cui_info_mmwbxbhszfhzmrylz')"
            style="width: 100%"
            :disabled="!!userId"
            @focus="
              inputReadonly = false;
              inputType = 'text';
            "
            @blur="inputType = 'password'"
          ></el-input>
        </el-form-item>
        <el-form-item key="mobile" :label="$t('cui_info_lian_xi_dian_hua')" prop="mobile">
          <el-input v-model="form.mobile" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item key="email" :label="$t('cui_info_you_xiang')" prop="email">
          <el-input v-model="form.email" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item key="langCode" :label="$t('cui_info_mo_ren_yu_zhong')" prop="langCode">
          <custom-select v-model="form.langCode" code="language_type" :isDefault="type === 'add'" width="100%" :props="{ label: 'name', value: 'value' }"></custom-select>
        </el-form-item>
        <el-form-item key="timeZoneId" :label="$t('cui_info_mo_ren_shi_qu')" prop="timeZoneId" v-if="timeZoneIdList.length > 1">
          <custom-select v-model="form.timeZoneId" url="timeZoneGetCompanyList" width="100%" :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"></custom-select>
        </el-form-item>
        <el-form-item key="dateFormat" :label="$t('cui_info_rqxsgs')" prop="dateFormat">
          <custom-select v-model="form.dateFormat" code="bas_date_format" width="100%"></custom-select>
        </el-form-item>
        <el-form-item key="isTime24h" :label="$t('cui_info_xiao_shi_zhi')" prop="isTime24h">
          <custom-select v-model="form.isTime24h" code="isynergy_cloud_bool" width="100%"></custom-select>
          <!-- <el-switch v-model="form.isTime24h" :active-value="1" :inactive-value="0"></el-switch> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="footer ub ub-xc ub-ae">
      <el-button @click="onCancel">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" v-if="type === 'add'" @click="saveUser()">{{ $t('cui_info_xia_yi_bu') }}</el-button>
      <el-button type="warning" v-if="type === 'edit'" @click="saveUser()">{{ $t('com_save') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

// cui_info_xia_yi_bu: 下一步// cui_info_yong_hu_bian_ma: 用户编码// cui_info_ygxm: 员工姓名// cui_info_deng_lu_mi_ma: 登录密码// cui_info_mmwbxbhszfhzmrylz: 密码8-16位，必须包含数字、符号、字母任意两种// cui_info_lian_xi_dian_hua: 联系电话// cui_info_you_xiang: 邮箱// cui_info_mo_ren_yu_zhong: 默认语种// cui_info_mo_ren_shi_qu: 默认时区// cui_info_rqxsgs: 日期显示格式// cui_info_xiao_shi_zhi: 24小时制// cui_info_cdyzgzfbxbhszfhzmrylz: 长度要在8~16个字符,必须包含数字、符号、字母任意两种// cui_info_bxbhszfhzmrylz: 必须包含数字、符号、字母任意两种// cui_info_cdyzgzf: 长度要在7~11个字符// cui_info_yxgsbzq: 邮箱格式不正确

export default {
  props: {
    type: String,
    userId: [String, Number],
  },
  data() {
    return {
      inputReadonly: true,
      inputType: 'text',
      form: {
        userCode: '',
        realName: '',
        // userName: '',
        loginPwd: '',
        mobile: '',
        langCode: '',
        email: '',
        timeZoneId: '',
        dateFormat: '',
        isTime24h: '',
      },
      timeZoneIdList: [],
    };
  },
  computed: {
    rules() {
      return {
        loginPwd: [
          {
            min: 8,
            max: 16,
            message: this.$t('cui_info_cdyzgzfbxbhszfhzmrylz'),
          },
          {
            validator: null,
            message: this.$t('cui_info_bxbhszfhzmrylz'),
          },
        ],
        mobile: {
          min: 7,
          max: 11,
          message: this.$t('cui_info_cdyzgzf'),
        },
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t('cui_info_yxgsbzq'),
          },
          { max: 50, message: ' ' },
        ],
      };
    },
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_company_user_item_info');
    this.getUserDate();
    this.getTimeZoneIdList();
  },
  methods: {
    i18nCallback: function () {
      this.rules.loginPwd[1].validator = (rule, value, callback) => {
        const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
        if (!reg.test(value.toString())) {
          callback(new Error());
        } else {
          callback();
        }
      };
    },
    getTimeZoneIdList: function () {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneIdList = res.data;
      });
    },
    // 获取用户信息
    getUserDate: function () {
      if (this.type === 'edit') {
        this.$getJSON(`${apis.User}/${this.userId}`).then((res) => {
          this.$setFormatData(this.form, res.data);
        });
      }
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 下一步
    onStep: function (userId) {
      this.$emit('step', {
        name: 'info',
        userId: userId,
        realName: this.form.realName,
      });
    },
    // 确认保存用户
    saveUser: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.type === 'add' && !this.userId) {
          this.saveAddUser();
        } else {
          this.saveEditUser();
        }
      });
    },
    // 保存新增用户
    saveAddUser: function () {
      this.$postJSON(apis.UserAdd, this.form).then((res) => {
        const userId = res.data || '';
        this.onStep(userId);
      });
    },
    // 保存编辑用户
    saveEditUser: function () {
      this.$postJSON(apis.UserUpdate, {
        userId: this.userId,
        realName: this.form.realName,
        userCode: this.form.userCode,
        mobile: this.form.mobile,
        sex: this.form.sex,
        langCode: this.form.langCode,
        email: this.form.email,
        timeZoneId: this.form.timeZoneId,
        dateFormat: this.form.dateFormat,
        isTime24h: this.form.isTime24h,
      }).then(() => {
        if (this.type === 'add') {
          this.onStep(this.userId);
        } else {
          this.$emit('refresh');
          this.$message({
            type: 'success',
            message: this.$t('com_handle_success'),
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.company-user-item-info-bd {
  .user-info {
    padding: 24px;
  }
  .footer {
    height: 88px;
    padding: 0 24px;
    background: #f8f9fa;
  }
}
</style>
